export default "__VITE_ASSET__DQYKzwTj__"